import styled from '@emotion/styled'
import { DynamicChatTimestamp } from 'components/composite/DynamicChatTimestamp'
import { ChatMessageAttachments } from 'components/core/ChatMessage'
import Column from 'components/core/Column'
import Row from 'components/core/Row'
import Typography from 'components/core/Typography'
import { DESIGN_TOKENS } from 'constants/color.constants'
import { SPACING } from 'constants/spacing.constants'
import { memo } from 'react'
import { Markdown } from 'components/core/Markdown'
import { pxToRem } from 'utils/rem.utils'

const StyledWilsonChatMessageUser = styled(Column)`
    max-width: ${pxToRem(400)};
    margin-left: auto;

    .wilsonChatMessageUser__header {
        letter-spacing: ${pxToRem(0.12)};
        width: 100%;

        .wilsonChatMessageUser__header__name {
            max-width: ${pxToRem(300)};
        }
    }

    .wilsonChatMessageUser__message {
        padding-top: ${SPACING.p1};
        padding-bottom: ${SPACING.p1};
        padding-left: ${SPACING.p2};
        padding-right: ${SPACING.p2};
        max-width: ${pxToRem(400)};
        border-top-right-radius: ${SPACING.p2};
        border-top-left-radius: ${SPACING.p2};
        border-bottom-left-radius: ${SPACING.p2};
        border-bottom-right-radius: ${SPACING.sm};
        background: ${DESIGN_TOKENS.wilson.blue};
        color: ${DESIGN_TOKENS.text.foreground};
        font-size: ${pxToRem(14)};
        line-height: ${pxToRem(20)};
        font-style: normal;
        font-weight: 420;
        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: break-word;
    }
`

export const WilsonChatMessageUser = memo(
    ({
        name,
        content,
        createdAt,
        attachments,
    }: {
        name?: string
        content: string
        createdAt?: string
        attachments?: { fileName: string; fileUrl: string }[]
    }) => {
        return (
            <StyledWilsonChatMessageUser gap="p1" alignItems="flex-end">
                <Row
                    gap="sm"
                    justifyContent="flex-end"
                    className="wilsonChatMessageUser__header"
                >
                    <div
                        className="wilsonChatMessageUser__header__name"
                        title={name}
                    >
                        <Typography
                            isBold
                            shouldTruncate
                            variant="caption"
                            color="primary"
                        >
                            {name}
                        </Typography>
                    </div>
                    <DynamicChatTimestamp dateTime={createdAt} />
                </Row>
                <div className="wilsonChatMessageUser__message">
                    <Markdown>{content}</Markdown>
                </div>
                {!!attachments?.length && (
                    <ChatMessageAttachments
                        align="end"
                        attachments={attachments.map((attachment) => ({
                            filename: attachment.fileName,
                            onDownload: async () => {
                                window.open(attachment.fileUrl, '_blank')
                            },
                        }))}
                    />
                )}
            </StyledWilsonChatMessageUser>
        )
    }
)
